import * as types from '../constants/actionsTypes';

const initialState = {
	loading: false,
	error: null,
	messageShowed: false,
	form: null
}

export default function (state = initialState, action) {
	switch(action.type) {
		case types.EXPORT_DATA_REQUEST:
			return {
				...state,
				loading: true,
				error: null
			}
		case types.EXPORT_DATA_SUCCESS:
			return {
				...state,
				loading: false,
				exportLink: action.exportData.report_url
			}
		case types.EXPORT_DATA_FAILURE:
			return {
				...state,
				loading: false,
				error: action.error
			}
		case types.CLEAR_EXPORT_LINK:
			return {
				...state,
				exportLink: null
			}
		case types.LOAD_CULTURES_BY_CATEGORY_REQUEST:
			return {
				...state,
				culturesLoading: true,
				cultures: []
			}
		case types.LOAD_CULTURES_BY_CATEGORY_FAILURE:
			return {
				...state,
				culturesLoading: false
			}
		case types.LOAD_CULTURES_BY_CATEGORY_SUCCESS:
			return {
				...state,
				culturesLoading: false,
				cultures: action.cultures
			}
		case types.UPDATE_COEFFICIENT_SUCCESS:
			return {
				...state,
				messageShowed: true,
				form: 'coefficientForm'
			}
		case types.UPDATE_COEFFICIENT_FAILURE:
			return {
				...state,
				messageShowed: true,
				error: action.error,
				form: 'coefficientForm'
			}
		case types.CLEAR_ALERT_MESSAGES:
			return {
				...state,
				error: null,
				messageShowed: false
			}
		case types.SAVE_CULTURE_SUCCESS:
		case types.DELETE_CULTURE_SUCCESS:
			return {
				...state,
				messageShowed: true,
				form: 'culturesForm'
			}
		case types.SAVE_CULTURE_FAILURE:
		case types.DELETE_CULTURE_FAILURE:
			return {
				...state,
				messageShowed: true,
				error: action.error,
				form: 'culturesForm'
			}
		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./reducers/settings.js